(function () {
    'use strict';
    
    /**
     * Service pour interagir avec l'API de forum
     */
    angular.module('observatoireApp')
        .factory('ForumApiService', ForumApiService);
    
    ForumApiService.$inject = ['$http', '$q'];
    
    function ForumApiService($http, $q) {
        
        var service = {
            getAllDiscussions: getAllDiscussions,
            getDiscussionById: getDiscussionById,
            getDiscussionsByJeuDonnees: getDiscussionsByJeuDonnees,
            createDiscussion: createDiscussion,
            updateDiscussion: updateDiscussion,
            deleteDiscussion: deleteDiscussion,
            // Méthodes pour gérer les réponses
            getReponsesByDiscussionId: getReponsesByDiscussionId,
            getReponseById: getReponseById,
            createReponse: createReponse,
            updateReponse: updateReponse,
            deleteReponse: deleteReponse
        };
        
        return service;
        
        /**
         * Récupère toutes les discussions du forum
         * @returns {Promise} Promesse contenant la liste des discussions
         */
        function getAllDiscussions() {
            console.log('ForumApiService: Appel de /api/budget-forum');
            return $http.get('/api/budget-forum')
                .then(function (response) {
                    console.log('ForumApiService: Réponse reçue de l\'API:', response);
                    console.log('ForumApiService: Status de la réponse:', response.status);
                    console.log('ForumApiService: Données brutes reçues:', response.data);
                    
                    // Vérifier que response.data est un tableau
                    if (!Array.isArray(response.data)) {
                        console.error('ForumApiService: Les données reçues ne sont pas un tableau:', response.data);
                        return [];
                    }
                    
                    // Convertir les dates en objets Date JavaScript
                    var discussions = response.data;
                    console.log('ForumApiService: Nombre de discussions avant traitement:', discussions.length);
                    console.log('ForumApiService: Dates brutes reçues du serveur avant conversion:', 
                        discussions.map(function(d) { return {id: d.id, createdAt: d.createdAt, updatedAt: d.updatedAt}; }));
                    
                    discussions.forEach(function(discussion, index) {
                        console.log('ForumApiService: Traitement discussion #' + index + ':', discussion);
                        
                        // Vérifier les propriétés importantes
                        if (!discussion.id) {
                            console.warn('ForumApiService: Discussion sans ID!');
                        }
                        if (!discussion.titre) {
                            console.warn('ForumApiService: Discussion sans titre!');
                        }
                        
                        // Conversion des dates
                        try {
                            // FORMAT 1: Tableau Java [année, mois, jour, heure, minute, seconde, nano]
                            if (discussion.createdAt && Array.isArray(discussion.createdAt)) {
                                discussion.createdAt = new Date(
                                    discussion.createdAt[0],
                                    discussion.createdAt[1] - 1, // Mois en JS est 0-based
                                    discussion.createdAt[2],
                                    discussion.createdAt[3],
                                    discussion.createdAt[4],
                                    discussion.createdAt[5],
                                    discussion.createdAt[6] ? Math.floor(discussion.createdAt[6] / 1000000) : 0
                                );
                            }
                            // FORMAT 2: Chaîne ISO ("2023-06-25T12:34:56Z")
                            else if (discussion.createdAt && typeof discussion.createdAt === 'string') {
                                if (discussion.createdAt.indexOf('T') > 0) {
                                    // C'est une chaîne ISO standard
                                    discussion.createdAt = new Date(discussion.createdAt);
                                } else {
                                    // C'est peut-être un timestamp en secondes ou millisecondes
                                    var timestamp = parseInt(discussion.createdAt, 10);
                                    if (!isNaN(timestamp)) {
                                        // Si c'est un timestamp en secondes (10 chiffres), convertir en ms
                                        if (timestamp < 10000000000) {
                                            timestamp = timestamp * 1000;
                                        }
                                        discussion.createdAt = new Date(timestamp);
                                    } else {
                                        // Fallback
                                        discussion.createdAt = new Date();
                                    }
                                }
                            }
                            // FORMAT 3: Nombre (timestamp)
                            else if (discussion.createdAt && typeof discussion.createdAt === 'number') {
                                // Si c'est un timestamp en secondes, convertir en ms
                                var timestamp = discussion.createdAt;
                                if (timestamp < 10000000000) {
                                    timestamp = timestamp * 1000;
                                }
                                discussion.createdAt = new Date(timestamp);
                            }
                            
                            // Même logique pour updatedAt
                            if (discussion.updatedAt && Array.isArray(discussion.updatedAt)) {
                                discussion.updatedAt = new Date(
                                    discussion.updatedAt[0],
                                    discussion.updatedAt[1] - 1,
                                    discussion.updatedAt[2],
                                    discussion.updatedAt[3],
                                    discussion.updatedAt[4],
                                    discussion.updatedAt[5],
                                    discussion.updatedAt[6] ? Math.floor(discussion.updatedAt[6] / 1000000) : 0
                                );
                            }
                            else if (discussion.updatedAt && typeof discussion.updatedAt === 'string') {
                                if (discussion.updatedAt.indexOf('T') > 0) {
                                    discussion.updatedAt = new Date(discussion.updatedAt);
                                } else {
                                    var timestamp = parseInt(discussion.updatedAt, 10);
                                    if (!isNaN(timestamp)) {
                                        if (timestamp < 10000000000) {
                                            timestamp = timestamp * 1000;
                                        }
                                        discussion.updatedAt = new Date(timestamp);
                                    } else {
                                        discussion.updatedAt = discussion.createdAt || new Date();
                                    }
                                }
                            }
                            else if (discussion.updatedAt && typeof discussion.updatedAt === 'number') {
                                var timestamp = discussion.updatedAt;
                                if (timestamp < 10000000000) {
                                    timestamp = timestamp * 1000;
                                }
                                discussion.updatedAt = new Date(timestamp);
                            }
                            
                            console.log('ForumApiService: Dates converties pour la discussion ' + discussion.id + ':', 
                                {createdAt: discussion.createdAt, updatedAt: discussion.updatedAt});
                                
                        } catch (e) {
                            console.error('ForumApiService: Erreur lors de la conversion des dates:', e, discussion);
                            discussion.createdAt = new Date();
                            discussion.updatedAt = new Date();
                        }
                    });
                    
                    console.log('ForumApiService: Discussions après traitement:', discussions);
                    return discussions;
                })
                .catch(function (error) {
                    console.error('ForumApiService: Erreur lors de la récupération des discussions:', error);
                    return $q.reject(error);
                });
        }
        
        /**
         * Récupère une discussion par son ID
         * @param {Number} id ID de la discussion
         * @returns {Promise} Promesse contenant la discussion
         */
        function getDiscussionById(id) {
            return $http.get('/api/budget-forum/' + id)
                .then(function (response) {
                    var discussion = response.data;
                    // Convertir les tableaux de dates en objets Date
                    if (discussion.createdAt && Array.isArray(discussion.createdAt)) {
                        discussion.createdAt = new Date(
                            discussion.createdAt[0],
                            discussion.createdAt[1] - 1,
                            discussion.createdAt[2],
                            discussion.createdAt[3],
                            discussion.createdAt[4],
                            discussion.createdAt[5],
                            discussion.createdAt[6] ? Math.floor(discussion.createdAt[6] / 1000000) : 0
                        );
                    }
                    if (discussion.updatedAt && Array.isArray(discussion.updatedAt)) {
                        discussion.updatedAt = new Date(
                            discussion.updatedAt[0],
                            discussion.updatedAt[1] - 1,
                            discussion.updatedAt[2],
                            discussion.updatedAt[3],
                            discussion.updatedAt[4],
                            discussion.updatedAt[5],
                            discussion.updatedAt[6] ? Math.floor(discussion.updatedAt[6] / 1000000) : 0
                        );
                    }
                    return discussion;
                })
                .catch(function (error) {
                    console.error('Erreur lors de la récupération de la discussion:', error);
                    return $q.reject(error);
                });
        }
        
        /**
         * Récupère les discussions par jeu de données
         * @param {String} jeuDonneesCode Code du jeu de données
         * @returns {Promise} Promesse contenant la liste des discussions
         */
        function getDiscussionsByJeuDonnees(jeuDonneesCode) {
            return $http.get('/api/budget-forum/by-jeu-donnees/' + jeuDonneesCode)
                .then(function (response) {
                    // Convertir les tableaux de dates en objets Date
                    var discussions = response.data;
                    discussions.forEach(function(discussion) {
                        if (discussion.createdAt && Array.isArray(discussion.createdAt)) {
                            discussion.createdAt = new Date(
                                discussion.createdAt[0],
                                discussion.createdAt[1] - 1,
                                discussion.createdAt[2],
                                discussion.createdAt[3],
                                discussion.createdAt[4],
                                discussion.createdAt[5],
                                discussion.createdAt[6] ? Math.floor(discussion.createdAt[6] / 1000000) : 0
                            );
                        }
                        if (discussion.updatedAt && Array.isArray(discussion.updatedAt)) {
                            discussion.updatedAt = new Date(
                                discussion.updatedAt[0],
                                discussion.updatedAt[1] - 1,
                                discussion.updatedAt[2],
                                discussion.updatedAt[3],
                                discussion.updatedAt[4],
                                discussion.updatedAt[5],
                                discussion.updatedAt[6] ? Math.floor(discussion.updatedAt[6] / 1000000) : 0
                            );
                        }
                    });
                    return discussions;
                })
                .catch(function (error) {
                    console.error('Erreur lors de la récupération des discussions par jeu de données:', error);
                    return $q.reject(error);
                });
        }
        
        /**
         * Crée une nouvelle discussion
         * @param {Object} discussion Objet contenant les données de la discussion
         * @returns {Promise} Promesse contenant la discussion créée
         */
        function createDiscussion(discussion) {
            return $http.post('/api/budget-forum', discussion)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (error) {
                    console.error('Erreur lors de la création de la discussion:', error);
                    return $q.reject(error);
                });
        }
        
        /**
         * Met à jour une discussion existante
         * @param {Number} id ID de la discussion
         * @param {Object} discussion Objet contenant les données à mettre à jour
         * @returns {Promise} Promesse contenant la discussion mise à jour
         */
        function updateDiscussion(id, discussion) {
            return $http.put('/api/budget-forum/' + id, discussion)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (error) {
                    console.error('Erreur lors de la mise à jour de la discussion:', error);
                    return $q.reject(error);
                });
        }
        
        /**
         * Supprime une discussion
         * @param {Number} id ID de la discussion à supprimer
         * @returns {Promise} Promesse résolue en cas de succès
         */
        function deleteDiscussion(id) {
            return $http.delete('/api/budget-forum/' + id)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (error) {
                    console.error('Erreur lors de la suppression de la discussion:', error);
                    return $q.reject(error);
                });
        }
        
        /**
         * Récupère les réponses d'une discussion
         * @param {Number} discussionId ID de la discussion
         * @returns {Promise} Promesse contenant la liste des réponses
         */
        function getReponsesByDiscussionId(discussionId) {
            return $http.get('/api/budget-forum/' + discussionId + '/reponses')
                .then(function (response) {
                    console.log('ForumApiService: Réponses reçues pour la discussion ' + discussionId + ':', response.data);
                    
                    // Vérifier que response.data est un tableau
                    if (!Array.isArray(response.data)) {
                        console.error('ForumApiService: Les données reçues ne sont pas un tableau:', response.data);
                        return [];
                    }
                    
                    // Convertir les dates en objets Date JavaScript
                    var reponses = response.data;
                    console.log('ForumApiService: Dates brutes reçues du serveur avant conversion:', 
                        reponses.map(function(r) { return {id: r.id, createdAt: r.createdAt, updatedAt: r.updatedAt}; }));
                    
                    reponses.forEach(function(reponse) {
                        try {
                            // FORMAT 1: Tableau Java [année, mois, jour, heure, minute, seconde, nano]
                            if (reponse.createdAt && Array.isArray(reponse.createdAt)) {
                                reponse.createdAt = new Date(
                                    reponse.createdAt[0],
                                    reponse.createdAt[1] - 1, // Mois en JS est 0-based
                                    reponse.createdAt[2],
                                    reponse.createdAt[3],
                                    reponse.createdAt[4],
                                    reponse.createdAt[5],
                                    reponse.createdAt[6] ? Math.floor(reponse.createdAt[6] / 1000000) : 0
                                );
                            }
                            // FORMAT 2: Chaîne ISO ("2023-06-25T12:34:56Z")
                            else if (reponse.createdAt && typeof reponse.createdAt === 'string') {
                                if (reponse.createdAt.indexOf('T') > 0) {
                                    // C'est une chaîne ISO standard
                                    reponse.createdAt = new Date(reponse.createdAt);
                                } else {
                                    // C'est peut-être un timestamp en secondes ou millisecondes
                                    var timestamp = parseInt(reponse.createdAt, 10);
                                    if (!isNaN(timestamp)) {
                                        // Si c'est un timestamp en secondes (10 chiffres), convertir en ms
                                        if (timestamp < 10000000000) {
                                            timestamp = timestamp * 1000;
                                        }
                                        reponse.createdAt = new Date(timestamp);
                                    } else {
                                        // Fallback
                                        reponse.createdAt = new Date();
                                    }
                                }
                            }
                            // FORMAT 3: Nombre (timestamp)
                            else if (reponse.createdAt && typeof reponse.createdAt === 'number') {
                                // Si c'est un timestamp en secondes, convertir en ms
                                var timestamp = reponse.createdAt;
                                if (timestamp < 10000000000) {
                                    timestamp = timestamp * 1000;
                                }
                                reponse.createdAt = new Date(timestamp);
                            }
                            // Valeur manquante
                            else if (reponse.createdAt === null || reponse.createdAt === undefined) {
                                reponse.createdAt = new Date();
                                console.warn('ForumApiService: Date de création manquante pour la réponse', reponse.id);
                            }

                            // Même logique pour updatedAt
                            if (reponse.updatedAt && Array.isArray(reponse.updatedAt)) {
                                reponse.updatedAt = new Date(
                                    reponse.updatedAt[0],
                                    reponse.updatedAt[1] - 1,
                                    reponse.updatedAt[2],
                                    reponse.updatedAt[3],
                                    reponse.updatedAt[4],
                                    reponse.updatedAt[5],
                                    reponse.updatedAt[6] ? Math.floor(reponse.updatedAt[6] / 1000000) : 0
                                );
                            }
                            else if (reponse.updatedAt && typeof reponse.updatedAt === 'string') {
                                if (reponse.updatedAt.indexOf('T') > 0) {
                                    reponse.updatedAt = new Date(reponse.updatedAt);
                                } else {
                                    var timestamp = parseInt(reponse.updatedAt, 10);
                                    if (!isNaN(timestamp)) {
                                        if (timestamp < 10000000000) {
                                            timestamp = timestamp * 1000;
                                        }
                                        reponse.updatedAt = new Date(timestamp);
                                    } else {
                                        reponse.updatedAt = reponse.createdAt || new Date();
                                    }
                                }
                            }
                            else if (reponse.updatedAt && typeof reponse.updatedAt === 'number') {
                                var timestamp = reponse.updatedAt;
                                if (timestamp < 10000000000) {
                                    timestamp = timestamp * 1000;
                                }
                                reponse.updatedAt = new Date(timestamp);
                            }
                            else if (reponse.updatedAt === null || reponse.updatedAt === undefined) {
                                reponse.updatedAt = reponse.createdAt || new Date();
                            }
                            
                            console.log('ForumApiService: Dates converties pour la réponse ' + reponse.id + ':', 
                                {createdAt: reponse.createdAt, updatedAt: reponse.updatedAt});
                            
                        } catch (e) {
                            console.error('ForumApiService: Erreur lors de la conversion des dates:', e, reponse);
                            reponse.createdAt = new Date();
                            reponse.updatedAt = new Date();
                        }
                    });
                    
                    console.log('ForumApiService: Réponses après conversion des dates:', reponses);
                    return reponses;
                })
                .catch(function (error) {
                    console.error('Erreur lors de la récupération des réponses:', error);
                    return $q.reject(error);
                });
        }
        
        /**
         * Récupère une réponse par son ID
         * @param {Number} id ID de la réponse
         * @returns {Promise} Promesse contenant la réponse
         */
        function getReponseById(id) {
            return $http.get('/api/budget-forum/reponses/' + id)
                .then(function (response) {
                    var reponse = response.data;
                    
                    // Convertir les dates
                    if (reponse.createdAt && Array.isArray(reponse.createdAt)) {
                        reponse.createdAt = new Date(
                            reponse.createdAt[0],
                            reponse.createdAt[1] - 1,
                            reponse.createdAt[2],
                            reponse.createdAt[3],
                            reponse.createdAt[4],
                            reponse.createdAt[5],
                            reponse.createdAt[6] ? Math.floor(reponse.createdAt[6] / 1000000) : 0
                        );
                    }
                    if (reponse.updatedAt && Array.isArray(reponse.updatedAt)) {
                        reponse.updatedAt = new Date(
                            reponse.updatedAt[0],
                            reponse.updatedAt[1] - 1,
                            reponse.updatedAt[2],
                            reponse.updatedAt[3],
                            reponse.updatedAt[4],
                            reponse.updatedAt[5],
                            reponse.updatedAt[6] ? Math.floor(reponse.updatedAt[6] / 1000000) : 0
                        );
                    }
                    
                    return reponse;
                })
                .catch(function (error) {
                    console.error('Erreur lors de la récupération de la réponse:', error);
                    return $q.reject(error);
                });
        }
        
        /**
         * Crée une nouvelle réponse pour une discussion
         * @param {Number} discussionId ID de la discussion
         * @param {Object} reponse Objet contenant les données de la réponse
         * @returns {Promise} Promesse contenant la réponse créée
         */
        function createReponse(discussionId, reponse) {
            return $http.post('/api/budget-forum/' + discussionId + '/reponses', reponse)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (error) {
                    console.error('Erreur lors de la création de la réponse:', error);
                    return $q.reject(error);
                });
        }
        
        /**
         * Met à jour une réponse existante
         * @param {Number} id ID de la réponse
         * @param {Object} reponse Objet contenant les données à mettre à jour
         * @returns {Promise} Promesse contenant la réponse mise à jour
         */
        function updateReponse(id, reponse) {
            return $http.put('/api/budget-forum/reponses/' + id, reponse)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (error) {
                    console.error('Erreur lors de la mise à jour de la réponse:', error);
                    return $q.reject(error);
                });
        }
        
        /**
         * Supprime une réponse
         * @param {Number} id ID de la réponse à supprimer
         * @returns {Promise} Promesse résolue en cas de succès
         */
        function deleteReponse(id) {
            return $http.delete('/api/budget-forum/reponses/' + id)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (error) {
                    console.error('Erreur lors de la suppression de la réponse:', error);
                    return $q.reject(error);
                });
        }
    }
})();
